import { Component, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { CodeVarcharService } from '../../../service/code-varchar/codevarchar-service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { sjisByteLength } from '../../../util/util';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6050.component.html',
  styleUrls: ['wa6050.component.scss']
})
export class Wa6050Component implements AfterViewInit {
  public componentTitle = 'WA6050:組替';

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // Define each input element (initial value and validation rule)
  public memoTx = new FormControl('', [Validators.maxLength(50)]);
  // build FormGroup
  srcForm = this.builder.group({});
  destForm = this.builder.group({});
  myForm = this.builder.group({
    memoTx: this.memoTx
  });

  // other variables

  // detail
  public srcDetails: [SrcDetail];
  public destDetails: [DestDetail];

  private memoTxCls = '';
  private errorInfo = '';
  private isShow0040 = false;
  private choose0040Index = 0;

  private isShow0010 = false;
  private choose0010Index = 0;

  private isShow0030 = false;
  private choose0030Index = 0;

  private isSubmitEnabled = false;
  private executewindow: boolean = false;

  @ViewChild('ScrollTop') ScrollTop: ElementRef;
  @ViewChild('caseNr') caseNr: ElementRef;
  @ViewChild('baraNr') baraNr: ElementRef;
  constructor(
    private router: Router,
    private builder: FormBuilder,
    private locaStockService: LocaStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private codeVarcharService: CodeVarcharService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.srcDetails = [new SrcDetail()];
    this.srcDetails.forEach(v => {
      v.caller = this;
    });
    this.destDetails = [new DestDetail()];
    this.destDetails.forEach(v => {
      v.caller = this;
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      sessionStorage.removeItem('isShowOwnerSelect');
    }, 500)
  }

  ngOnDestroy() : void {
    sessionStorage.removeItem('isOwnerDisable');
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  searchSrcLocaStock(idx) {
    this.errorInfo = '';
    this.choose0040Index = idx;
    this.isShow0040 = true;
  }

  deleteSrcLocaStock(idx) {
    if (this.srcDetails.length === 1 && idx === 0) {
      this.errorInfo = '明細数をゼロにすることはできません';
      return;
    }
    this.srcDetails.splice(idx, 1);

    for (const detail of this.srcDetails) {
      detail.isAllowRemove = this.srcDetails.length > 1;
    }
  }

  isValidSrcDetail() {

    let valid = true;
    for (const detail of this.srcDetails) {
      if (detail.itemCd.value === '') {
        detail.itemCd.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.caseNr.errors !== null) {
        detail.caseNr.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.baraNr.errors !== null) {
        detail.baraNr.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.pcsNr.errors !== null || detail.pcsNr.value <= 0) {
        detail.pcsNr.markAsTouched({ onlySelf: true });
        valid = false;
      }
    }
    return valid;
  }

  addSrcDetail() {
    this.errorInfo = '';
    //let valid = this.isValidSrcDetail();
    //if (valid) {
    const newDetail = new SrcDetail();
    newDetail.caller = this;
    this.srcDetails.push(newDetail);
    //}

    for (const detail of this.srcDetails) {
      detail.isAllowRemove = this.srcDetails.length > 1;
    }
  }

  searchDestItem(idx) {
    this.errorInfo = '';
    this.choose0010Index = idx;
    this.isShow0010 = true;
  }

  deleteDestItem(idx) {
    this.errorInfo = '';
    if (this.destDetails.length === 1 && idx === 0) {
      this.errorInfo = validation.message.delete.detail;
      return;
    }
    this.destDetails.splice(idx, 1);

    for (const detail of this.destDetails) {
      detail.isAllowRemove = this.destDetails.length > 1;
    }
  }

  searchDestLoca(idx) {
    this.errorInfo = '';
    this.choose0030Index = idx;
    this.isShow0030 = true;
  }

  isValidDestDetail() {
    let valid = true;
    for (const detail of this.destDetails) {
      if (detail.itemCd.value === '') {
        detail.itemCd.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.locaCd.value === '') {
        detail.locaCd.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.caseNr.errors !== null) {
        detail.caseNr.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.baraNr.errors !== null) {
        detail.baraNr.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.pcsNr.errors !== null || detail.pcsNr.value <= 0) {
        detail.pcsNr.markAsTouched({ onlySelf: true });
        valid = false;
      }
      if (detail.isStockDtDay && detail.stockDt === '') {
        valid = false
      }
      if (detail.lotTxCls === 'error' ||
          (detail.lotTxCls !== 'disabled' && detail.lotTx.length === 0)) {
        valid = false;
      }
    }
    return valid;
  }

  addDestDetail() {
    this.errorInfo = '';
    // let valid = this.isValidDestDetail();
    // if (valid) {
    const newDetail = new DestDetail();
    newDetail.caller = this;
    this.destDetails.push(newDetail);
    // }

    for (const detail of this.destDetails) {
      detail.isAllowRemove = this.destDetails.length > 1;
    }
  }

  execute() {
    this.errorInfo = '';
    if (!this.isValidSrcDetail() || !this.isValidDestDetail()) {
      return;
    }
    this.working = true;
    const srcdetails = [];
    for (const det of this.srcDetails) {
      srcdetails.push(det.toJson());
    }
    const destdetails = [];
    for (const det of this.destDetails) {
      destdetails.push(det.toJson());
    }
    this.locaStockService
      .recombine({
        srcdetails: srcdetails,
        destdetails: destdetails,
        memoTx: this.memoTx.value,
        updprogramCd: 'wa6050'
      })
      .then(outputJson => {
        sessionStorage.setItem('SuccessInfoMessage', '登録完了しました。');

        let _Scr = this.ScrollTop;
        this.working = false;
        //this.router.navigate(['wa0002']);
        this.executewindow = false;
        this.srcDetails = [new SrcDetail()];
        this.srcDetails.forEach(v => {
          v.caller = this;
        });
        this.destDetails = [new DestDetail()];
        this.destDetails.forEach(v => {
          v.caller = this;
        });
        _Scr.nativeElement.scrollTop = 0;
      })
      .catch(error => {
        this.working = false;
        this.executewindow = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  memoTxArea() {
    this.errorInfo = '';
  }

  changeOwner() {
    this.errorInfo = '';
  }


  cancel() {
    this.router.navigate([
      JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3  
      ? 'wa0003' : 'wa0002']);
  }

  onClose0040(selectedNodeData: any) {
    console.log(selectedNodeData);
    this.isShow0040 = false;
    if (selectedNodeData != null) {
      let locaStockP = selectedNodeData;
      let idx = this.choose0040Index;
      this.srcDetails[idx].locastockpId = locaStockP.locastockpId;
      this.srcDetails[idx].locaCd = locaStockP.locaCd;
      this.srcDetails[idx].locaTx = locaStockP.locaTx;
      this.srcDetails[idx].typestockTx = locaStockP.typestockTx;
      this.srcDetails[idx].typecoldTx = locaStockP.typecoldTx;
      this.srcDetails[idx].itemId = locaStockP.itemId;
      this.srcDetails[idx].itemCd.setValue(locaStockP.itemCd);
      this.srcDetails[idx].itemTx = locaStockP.itemTx;
      this.srcDetails[idx].amountNr = locaStockP.amountNr;
      this.srcDetails[idx].lotTx = locaStockP.lotTx;
      this.srcDetails[idx].uselimitDt = locaStockP.uselimitDt;
      this.srcDetails[idx].stockDt = locaStockP.stockDt;
      this.srcDetails[idx].caseNr.setValue(0);
      this.srcDetails[idx].baraNr.setValue(0);
      this.srcDetails[idx].pcsNr.setValue(null);

      this.srcDetails[idx].caseNr.enable();
      this.srcDetails[idx].baraNr.enable();
      this.srcDetails[idx].caseNrCls = '';
      this.srcDetails[idx].baraNrCls = '';
    }
  }

  async onClose0010(selectedNodeData: any) {
    this.isShow0010 = false;
    if (selectedNodeData != null) {
      let item = selectedNodeData;
      let idx = this.choose0010Index;

      this.destDetails[idx].itemId = item.itemId;
      this.destDetails[idx].itemCd.setValue(item.itemCd);
      this.destDetails[idx].itemTx = item.itemTx;
      this.destDetails[idx].amountNr = item.caseamountNr;
      this.destDetails[idx].lotFl = item.lotFl;
      this.destDetails[idx].uselimitFl = item.uselimitFl;

      this.destDetails[idx].isItemChoose = true;
      try {
        this.destDetails[idx].isStockDtDay = await this.requestStockDt(item.ownerId)
      } catch(err){}

      this.destDetails[idx].checkInputState();
    }
  }

  onClose0030(selectedNodeData: any) {
    this.isShow0030 = false;

    if (selectedNodeData != null) {
      let loca = selectedNodeData;
      let idx = this.choose0030Index;

      this.destDetails[idx].locaId = loca.locaId;
      this.destDetails[idx].locaCd.setValue(loca.locaCd);
      this.destDetails[idx].locaTx = loca.locaTx;
      this.destDetails[idx].typestockTx = loca.typestockTx;
      this.destDetails[idx].typecoldTx = loca.typecoldTx;

      this.destDetails[idx].isLocaChoose = true;
      this.destDetails[idx].checkInputState();
    }
  }

  ngDoCheck() {

    this.memoTxCls = this.memoTx.errors !== null ? 'error' : this.memoTx.value.length > 0 ? 'active' : '';
    this.isSubmitEnabled = this.isValidSrcDetail() && this.isValidDestDetail() && this.memoTx.errors == null;

  }

  async requestStockDt (ownerId) {
    const result = await this.codeVarcharService.get(ownerId, 'INSTOCK', 'TYPE_STOCK_DT')
    return 'DAY' === result['data'].value
  }
}

class SrcDetail {
  public locastockpId: number;
  public locaCd: string;
  public locaTx: string;
  public typestockTx: string;
  public typecoldTx: string;
  public itemId: string;
  public itemCd: FormControl;
  public itemTx: string;
  public amountNr: number;
  public lotTx: string;
  public uselimitDt: string;
  public stockDt: string;
  public caseNr: FormControl;
  public baraNr: FormControl;
  public pcsNr: FormControl;

  public caseNrCls: string;
  public baraNrCls: string;
  public isAllowRemove = false;
  public caller = null;

  constructor(det?: any) {
    if (!det) {
      det = {
        locastockpId: 0,
        itemId: 0,
        amountNr: null,
        caseNr: 0,
        baraNr: 0,
        pcsNr: null
      };
    }
    this.locastockpId = det.locastockpId;
    this.locaCd = det.locaCd || '';
    this.locaTx = det.locaTx || '';
    this.typestockTx = det.typestockTx || '';
    this.typecoldTx = det.typecoldTx || '';
    this.itemId = det.itemId;
    this.itemCd = new FormControl(det.itemCd || '', [Validators.required]);
    this.itemTx = det.itemTx || '';
    this.amountNr = det.amountNr;
    this.lotTx = det.lotTx || '';
    this.uselimitDt = det.uselimitDt || '';
    this.stockDt = det.stockDt || '';
    this.caseNr = new FormControl(det.caseNr, [Validators.required]);
    this.baraNr = new FormControl(det.baraNr, [Validators.required]);
    this.pcsNr = new FormControl(det.pcsNr, [Validators.required, Validators.min(0), Validators.max(999999999)]);

    this.caseNr.disable();
    this.baraNr.disable();
    //this.pcsNr.disable();
    this.caseNrCls = 'disabled';
    this.baraNrCls = 'disabled';
  }

  toJson(): object {
    return {
      locastockpId: this.locastockpId,
      locaCd: this.locaCd || '',
      locaTx: this.locaTx || '',
      typestockTx: this.typestockTx || '',
      typecoldTx: this.typecoldTx || '',
      itemId: this.itemId,
      itemCd: this.itemCd.value,
      itemTx: this.itemTx || '',
      amountNr: this.amountNr,
      lotTx: this.lotTx || '',
      uselimitDt: this.uselimitDt || '',
      stockDt: this.stockDt || '',
      caseNr: this.caseNr.value,
      baraNr: this.baraNr.value,
      pcsNr: this.pcsNr.value
    };
  }

  onChangePcsNr() {
    this.caller.errorInfo = '';

    if (this.caseNr.value < 0) this.caseNr.setValue(0);
    if (this.baraNr.value < 0) this.baraNr.setValue(0);
    this.caseNrCls = this.caseNr.errors !== null ? 'error' : this.caseNr.value > 0 ? 'active' : '';
    this.baraNrCls = this.baraNr.errors !== null ? 'error' : this.baraNr.value > 0 ? 'active' : '';
    this.pcsNr.setValue(this.getPcsNr());
  }

  getPcsNr() {
    if (this.caseNr.value != null && this.baraNr.value != null) return parseInt(this.caseNr.value) * this.amountNr + parseInt(this.baraNr.value);
    return 0;
  }
}

function cutStrByFullLength(str = '', maxLength) {
  let showLength = 0
  return str.split('').reduce((pre, cur) => {
    showLength = sjisByteLength(pre) + 1;
    if (showLength <= maxLength) {
      return pre + cur
    }
    return pre
  }, '')
}

class DestDetail {
  public itemId: string;
  public itemCd: FormControl;
  public itemTx: string;
  public amountNr: number;
  public lotFl: number;
  public uselimitFl: number;
  public locaId: number;
  public locaCd: FormControl;
  public locaTx: string;
  public typestockTx: string;
  public typecoldTx: string;
  public lotTx: string;
  public uselimitDt: string;
  public stockDt: string;
  public caseNr: FormControl;
  public baraNr: FormControl;
  public pcsNr: FormControl;

  public lotTxCls: string;
  public uselimitDtCls: string;
  public stockDtCls: string;
  public caseNrCls: string;
  public baraNrCls: string;
  public isAllowRemove = false;
  public isItemChoose = false;
  public isLocaChoose = false;
  public isStockDtDay = false;

  public caller = null;

  constructor(det?: any) {
    if (!det) {
      det = {
        itemId: 0,
        amountNr: null,
        lotFl: 0,
        uselimitFl: 0,
        locaId: 0,
        caseNr: 0,
        baraNr: 0,
        pcsNr: null
      };
    }
    this.itemId = det.itemId;
    this.itemCd = new FormControl(det.itemCd || '', [Validators.required]);
    this.itemTx = det.itemTx || '';
    this.amountNr = det.amountNr;
    this.lotFl = det.lotFl;
    this.uselimitFl = det.uselimitFl;
    this.locaId = det.locaId;
    this.locaCd = new FormControl(det.locaCd || '', [Validators.required]);
    this.locaTx = det.locaTx || '';
    this.typestockTx = det.typestockTx || '';
    this.typecoldTx = det.typecoldTx || '';
    this.lotTx = det.lotTx || '';
    this.uselimitDt = det.uselimitDt || '';
    this.stockDt = det.stockDt || '';
    this.caseNr = new FormControl(det.caseNr, [Validators.required]);
    this.baraNr = new FormControl(det.baraNr, [Validators.required]);
    this.pcsNr = new FormControl(det.pcsNr, [Validators.required, Validators.min(0), Validators.max(999999999)]);

    this.caseNr.disable();
    this.baraNr.disable();
    // this.pcsNr.disable();
    this.lotTxCls = 'disabled';
    this.uselimitDtCls = 'disabled';
    this.stockDtCls = 'disabled';
    this.caseNrCls = 'disabled';
    this.baraNrCls = 'disabled';
  }

  toJson(): object {
    return {
      itemId: this.itemId,
      itemCd: this.itemCd.value,
      itemTx: this.itemTx || '',
      amountNr: this.amountNr,
      lotFl: this.lotFl,
      uselimitFl: this.uselimitFl,
      locaId: this.locaId,
      locaCd: this.locaCd.value,
      locaTx: this.locaTx,
      typestockTx: this.typestockTx || '',
      typecoldTx: this.typecoldTx || '',
      lotTx: this.lotTx || '',
      uselimitDt: this.uselimitDt || '',
      stockDt: this.stockDt || '',
      caseNr: this.caseNr.value,
      baraNr: this.baraNr.value,
      pcsNr: this.getPcsNr(),
      isStockDtDay: this.isStockDtDay
    };
  }

  locaTxIn() {
    const len = sjisByteLength(this.lotTx)
    this.caller.errorInfo = '';
    this.lotTxCls = this.isItemChoose && this.isLocaChoose && this.lotFl === 1 ?
      (this.lotTx !== null ? len > validation.lotTx.maxByteLength ? 'error' : 'active' : 'active') : 'disabled';
  }

  useDtm() {
    this.caller.errorInfo = '';

    this.uselimitDtCls = this.isItemChoose && this.isLocaChoose ? (this.uselimitFl === 1 ? (this.uselimitDt !== null ? 'active' : '') : 'disabled') : 'disabled';
  }

  stoDtm() {
    this.caller.errorInfo = '';

    this.stockDtCls = this.isItemChoose && this.isLocaChoose ? (!this.isStockDtDay ? 'disabled' : (this.stockDt !== null ? 'active' : '')) : 'disabled';
  }

  onChangePcsNr() {
    this.caller.errorInfo = '';

    if (this.caseNr.value < 0) this.caseNr.setValue(0);
    if (this.baraNr.value < 0) this.baraNr.setValue(0);
    this.caseNrCls = this.isItemChoose && this.isLocaChoose ? (this.caseNr.errors !== null ? 'error' : this.caseNr.value > 0 ? 'active' : '') : 'disabled';
    this.baraNrCls = this.isItemChoose && this.isLocaChoose ? (this.baraNr.errors !== null ? 'error' : this.baraNr.value > 0 ? 'active' : '') : 'disabled';
    this.pcsNr.setValue(this.getPcsNr());
  }

  getPcsNr() {
    if (this.caseNr.value != null && this.baraNr.value != null) return parseInt(this.caseNr.value) * this.amountNr + parseInt(this.baraNr.value);
    return 0;
  }

  checkInputState() {
    if (!(this.isItemChoose && this.isLocaChoose)) return;

    this.caseNr.setValue(0);
    this.baraNr.setValue(0);
    this.pcsNr.setValue(0);

    this.locaTxIn();
    this.useDtm();
    this.stoDtm();

    this.caseNr.enable();
    this.baraNr.enable();
    this.caseNrCls = '';
    this.baraNrCls = '';
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6050/wa6050.component.ts